'use strict';

/**
 * View for rendering the profile in the navigation
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var NavigationSetsListView = require('../partials/navigation-sets-list');
var NavigationStoragesListView = require('../partials/navigation-storages-list');

var template = require('../../templates/partials/navigation-catalog.hbs');

var NavigationCatalogView = LayoutView.extend({
    template: template,

    tagName: 'ul',

    regions: {
        subnavSetsRegion: '.navigation-sets-subnav-region',
        subnavStoragesRegion: '.navigation-storages-subnav-region',
    },

    ui: {
        catalogSwitcher: '.catalog-switcher',
        catalogsList: '.catalogs',
        importStatus: '[data-role="import-status"]',
        navCountObjects: '.nav-count-objects',
        navCountSets: '.nav-count-sets',
        navCountStorages: '.nav-count-storages',
        navCountImports: '.nav-count-imports',
    },

    events: {
        'click @ui.catalogSwitcher': 'toggleCatalogs',
    },

    importCount: 0,

    initialize: function() {
        this.model = this.collection.getActiveCatalog();

        this.updateCounts = _.debounce(this.updateCounts.bind(this), 300);

        if (this.model) {
            this.listenTo(this.model, 'change:objectsCount change:setsCount change:storagesCount change:importsCount', this.updateCounts.bind(this));
            this.listenTo(this.model.objects, 'add remove reset change', this.updateCounts.bind(this));
            this.listenTo(this.model.imports, 'add remove reset change', this.updateImportState.bind(this));
        }
    },

    onRender: function() {
        this.updateCounts();
        this.showSetChildViews();
        this.showStorageChildViews();
    },

    toggleCatalogs: function(event) {
        this.ui.catalogsList.toggleClass('active')
    },

    /**
     * Shows the childviews for sets
     */
    showSetChildViews: function() {
        var catalog = this.model;

        if (catalog) {
            var filteredCollection = catalog.sets.getFilteredCollection(function (model) {
                return model.get('restricted') !== true;
            });

            var setsListView = new NavigationSetsListView({
                catalog: catalog,
                collection: filteredCollection,
                sortDefault: 'name.asc',
            });

            this.listenTo(setsListView, 'add:child', this.handleNewLinks.bind(this));

            this.subnavSetsRegion.show(setsListView);
        }
    },

    /**
     * Shows the childviews for storages
     */
    showStorageChildViews: function() {
        if (App.user.get('licenseStorages')) {
            var catalog = this.model;

            if (catalog) {
                var filteredCollection = catalog.storages.getFilteredCollection(function (model) {
                    return model.get('isRoot') === 1 || model.get('storType') === 'status';
                });

                var storagesListView = new NavigationStoragesListView({
                    catalog: catalog,
                    collection: filteredCollection,
                    sortDefault: 'storType.asc-name.asc',
                });

                this.listenTo(storagesListView, 'add:child', this.handleNewLinks.bind(this));

                this.subnavStoragesRegion.show(storagesListView);
            }
        }
    },

    updateCounts: function() {
        var catalog = this.model;

        if (catalog && !this.isDestroyed) {
            this.ui.navCountObjects.html(catalog.get('objectsCount'));
            this.ui.navCountSets.html(catalog.get('setsCount'));
            this.ui.navCountStorages.html(catalog.get('storagesCount'));
            this.ui.navCountImports.html(catalog.get('importsCount'));

            if (catalog.get('importsCount') > 0) {
                this.ui.importStatus.attr('data-status', 'finish'); //fade in imports count
            }

            //update locality filtered navigation counts
            if (catalog.objects.length) {
                this.$('[data-count-filter]').each(function(index, link) {
                    link = $(link);
                    var filter = link.data('count-filter');
                    var count = catalog.objects.getFilteredCount(filter);
                    link.find('.count').text(count);
                    link.toggle(count !== 0);
                });
            }
        }
    },

    handleNewLinks: function() {
        this.trigger('links:updated');
    },

    updateImportState: function(data) {
        this.ui.importStatus.attr('data-status', 'none');

        if (_.isObject(data)) {
            var collection = this.model.imports;
            if (collection.unfinished().length) {
                this.ui.importStatus.attr('data-status', 'loading');
            }
        }
    },

    /**
     * Get proper continent name based on language
     * @param {string} name The english continent name from config
     * @returns {string} The continent name based on the language
     */
    getProperContinentName: function(name) {
        name = name.replace(/\s/g, '-').toLocaleLowerCase();

        return App.t('global::continents:' + name);
    },
});

module.exports = NavigationCatalogView;